<template>
  <div class="card step-tracker mb-3">
    <div class="card-body py-3">
      <div class="d-flex flex-wrap align-items-center">
        <div v-for="step in steps"
             :key="step.id"
             class="step-item d-flex align-items-center mr-3 mb-2"
             :class="{
               'is-active': currentScreen === step.id,
               'is-done': currentScreen > step.id,
               'is-disabled': step.id > currentScreen
             }"
             @click="handleStepClick(step.id)">
          <div class="step-circle mr-2">{{ step.id }}</div>
          <div>
            <div class="font-weight-bold">{{ step.title }}</div>
            <div class="text-muted small">{{ step.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepTracker",
  props: {
    steps: {
      type: Array,
      required: true
    },
    currentScreen: {
      type: Number,
      required: true
    }
  },
  methods: {
    handleStepClick(target) {
      if (target >= this.currentScreen) return; // only allow reverse navigation
      this.$emit("step-change", target);
    }
  }
};
</script>

<style lang="scss" scoped>
.step-tracker {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.step-item {
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 8px;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.step-item.is-disabled {
  opacity: 0.55;
  cursor: default;
}

.step-item.is-active {
  background: #e3f2fd;
  border-color: #90caf9;
}

.step-item.is-done {
  background: #e8f5e9;
  border-color: #a5d6a7;
}

.step-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #4a5568;
  flex-shrink: 0;
}

.step-item.is-active .step-circle {
  background: #2196f3;
  color: #fff;
}

.step-item.is-done .step-circle {
  background: #43a047;
  color: #fff;
}
</style>
